import  Vue  from  'vue';
import  Router  from  'vue-router';
Vue.use(Router);

let router = new Router({ 
	 // mode: 'hash',
	routes: [
			{
			  path:'/systemnews',//系统消息
			  component: () => import('@/views/chatpage/systemNews.vue'),
			  meta: { keepAlive: false },
			},
			{
			  path:'/sendmessage',//发送消息
			  component: () => import('@/views/chatpage/sendMessage.vue'),
			  meta: { keepAlive: false },
			},
			{
			  path:'/chatlist',//消息列表
			  component: () => import('@/views/chatpage/chatList.vue'),
			  meta: { keepAlive: false },
			},
			{
			  path: '/',
			  redirect: () => {
			    return '/bookcity'
			  },
			  meta: {
			  showTabbar: true,
			  },
			},
			{
			  path: '/searchPage',
			  component: () => import('@/views/searchPage.vue'),
			  meta: { keepAlive: false ,
			  showTabbar: true,
			  },
			},
			{
			  path:'/bookinfo',//书本详情
			  component: () => import('@/views/bookcity/bookinfo.vue'),
			  meta: { keepAlive: false },
			},
			{
			  path:'/pldy',//批量订阅
			  component: () => import('@/views/bookcity/pldy.vue'),
			  meta: { keepAlive: false },
			},
			{
				path:'/yjjb',//云锦金榜
				component: () => import('@/views/bookcity/yjjb'),
				meta: { keepAlive: false },
			},
			{
			  path: '/searchQuery',
			  component: () => import('@/views/search/searchQuery.vue'),
			  meta: {
			    title: '搜索查询',
				keepAlive: false
				}
			},
			{
			  path: '/searchResult',
			  component: () => import('@/views/search/searchResult.vue'),
			  meta: {
			    title: '搜索结果页',
				keepAlive: false
				}
			},
			{
			  path: '/searchSelect',
			  component: () => import('@/views/search/searchSelect.vue'),
			  meta: {
			    title: '搜索书单选择结果页',
				keepAlive: false
				}
			},
			{
			  path: '/bookshelf',//书架
			  component: () => import('@/views/bookshelfPage.vue'),
			  meta: { keepAlive: false ,
			  showTabbar: true,
			  },
			},
			{
			  path: '/bookshelfindex',//书架
			  component: () => import('@/views/bookshelf/bookshelfIndex.vue'),
			  meta: { keepAlive: false ,
			  showTabbar: true,
			  },
			},
			{
			  path: '/bookdy',//书架
			  component: () => import('@/views/bookshelf/bookdy.vue'),
			  meta: { keepAlive: false ,
			  showTabbar: true,
			  },
			},
			{
			  path: '/bookcity',//书城
			  component: () => import('@/views/bookcityPage.vue'),
			  meta: { keepAlive: true ,
			  showTabbar: true,
			  },
			},
			{
			  path: '/forum',//论坛
			  component: () => import('@/views/forumPage.vue'),
			  meta: { keepAlive: false ,
			  showTabbar: true,
			  },
			},
			{
				path: '/bankuaijinghua',//论坛 -- 交流区 -- 板块精华
				component: () => import('@/views/forum/bankuaijinghua'),
				meta: { keepAlive: false },
			},
			{
				path: '/fbxt',//论坛  -- 发表新帖
				component: () => import('@/views/forum/fbxt'),
				meta: { keepAlive: false },
			},
			{
			  path: '/grzx',//个人中心
			 component: () => import('@/views/forum/grzx'),
			 meta: { keepAlive: false },
			},
			{
				path: '/tieziInfo',//帖子详情
				component: () => import('@/views/forum/tieziInfo'),
				meta: { keepAlive: false },
			},
			{
				path: '/forum_upimg',//论坛回复 图片输入
				component: () => import('@/views/forum/forum_upimg'),
				meta: { keepAlive: false },
			},
			{
				path: '/userinfo',//我的
				component: () => import('@/views/userinfo.vue'),
				meta: { keepAlive: false ,
				showTabbar: true,
				},
			},
			{
				path:'/yanqing',//首页一级导航 ---- 言情
				component: () => import('@/views/bookcity/yanqing'),
				meta: { keepAlive: true },
			},
			{
				path:'/gdyq',//古代言情
				component: () => import('@/views/bookcity/gdyq'),
				meta: { keepAlive: true },
			},
			{
				path:'/xdyq',//现代言情
				component: () => import('@/views/bookcity/xdyq'),
				meta: { keepAlive: true },
			},
			{
				path:'/hxyq',//幻想言情
				component: () => import('@/views/bookcity/hxyq'),
				meta: { keepAlive: true },
			},
			{
				path:'/chunai',//纯爱
				component: () => import('@/views/bookcity/chunai'),
				meta: { keepAlive: true },
			},
			{
				path:'/chunai_gdca',//古代纯爱
				component: () => import('@/views/bookcity/chunai_gdca'),
				meta: { keepAlive: true },
			},
			{
				path:'/chunai_xdca',//首页一级导航 ---- 现代纯爱
				component: () => import('@/views/bookcity/chunai_xdca'),
				meta: { keepAlive: true },
			},
			{
				path:'/chunai_hxca',//首页一级导航 ---- 幻想纯爱
				component: () => import('@/views/bookcity/chunai_hxca'),
				meta: { keepAlive: true },
			},
			{
				path:'/chunai_bh',//首页一级导航 ---- 百合
				component: () => import('@/views/bookcity/chunai_bh'),
				meta: { keepAlive: true },
			},
			{
				path:'/yansheng',//首页一级导航 ---- 衍生
				component: () => import('@/views/bookcity/yansheng'),
				meta: { keepAlive: true },
			},
			{
				path:'/yansheng_ca',//衍生纯爱
				component: () => import('@/views/bookcity/yansheng_ca'),
				meta: { keepAlive: true },
			},
			{
				path:'/yansheng_yq',//衍生言情
				component: () => import('@/views/bookcity/yansheng_yq'),
				meta: { keepAlive: true },
			},
			{
				path:'/wangqixianmian',//首页--限免 -- 往期限免
				component: () => import('@/views/bookcity/wangqixianmian'),
				meta: { keepAlive: true },
			},
			{
				path:'/cp',
				component: () => import('@/views/bookcity/CP'),
				meta: { keepAlive: true },
			},
			{
				path:'/bookdyinfo',//书单详情
				component: () => import('@/views/bookshelf/bookdyinfo'),
				meta: { keepAlive: false },
			},
			{
				path:'/cjsd',//创建书单
				component: () => import('@/views/bookshelf/cjsd'),
				meta: { keepAlive: false },
			},
			{
				path:'/bookPinglun',//书单评论
				component: () => import('@/views/bookshelf/bookPinglun'),
				meta: { keepAlive: false },
			},
			{
				path: '/comment',//评论
				component: () => import('@/views/bookshelf/comment'),
				meta: { keepAlive: false },
			},
			{
				path:'/dzzhuanlan',//读者专栏 -- 我的云书
				component: () => import('@/views/bookshelf/dzzhuanlan'),
				meta: { keepAlive: false },
			},
			{
				path:'/autherZl',//作者专栏 -- 我的云卷
				component: () => import('@/views/bookshelf/autherZl'),
				meta: { keepAlive: false },
			},
			{
				path: '/qingjia',//请假
				component: () => import('@/views/qingjia'),
				meta: { keepAlive: false },
			},
			{
				path: '/queryQingjia',//请假
				component: () => import('@/views/queryQingjia'),
				meta: { keepAlive: false },
			},
			{
				path: '/login',//登录
				component: () => import('@/views/login/login'),
				meta: { keepAlive: false },
			},
			{
				path: '/emailLogin',//邮箱登录
				component: () => import('@/views/login/emailLogin'),
				meta: { keepAlive: false },
			},
			{
				path: '/yanzhengmalogin',//验证码登录
				component: () => import('@/views/login/yzmlogin'),
				meta: { keepAlive: false },
			},
			{
				path: '/reseatLogin',//忘记密码登录
				component: () => import('@/views/login/reseatLogin'),
				meta: { keepAlive: false },
			},
			{
				path: '/registXy',//用户注册协议
				component: () => import('@/views/login/registXy'),
				meta: { keepAlive: false },
			},
			{
				path: '/privacyAgreement',//隐私协议
				component: () => import('@/views/login/privacyAgreement'),
				meta: { keepAlive: false },
			},
			{
				path: '/regist',//注册
				component: () => import('@/views/login/regist'),
				meta: { keepAlive: false },
			},
			{
				path: '/emailRegist',//邮箱笔名注册
				component: () => import('@/views/login/emailRegist'),
				meta: { keepAlive: false },
			},
			{
				path: '/gdyanqingtit',//古代言情 滑动导航(往期限时一分界面)
				component: () => import('@/views/gudaiyanqing/yanqing'),
				meta: { keepAlive: false },
			},
			{
				path: '/wanjiegengduo',//完结 滑动导航(完结更多界面)
				component: () => import('@/views/gudaiyanqing/wanjiegengduo'),
				meta: { keepAlive: false },
			},
			{
				path: '/wanjiejingpingengduo',//完结精品 滑动导航(完结精品更多界面)
				component: () => import('@/views/gudaiyanqing/wanjiejingpingengduo'),
				meta: { keepAlive: false },
			},
			{
				path: '/gudaiyanqing',//古代言情 滑动导航(古代言情 界面)
				component: () => import('@/views/gudaiyanqing/gudaiyanqing'),
				meta: { keepAlive: false },
			},
			// 我的界面 -- 子页面
			{
				path: '/UserZL',//个人资料
				component: () => import('@/views/userPage/userZL'),
				meta: { keepAlive: false },
			},
			{
				path: '/qjyl',//琼浆玉露
				component: () => import('@/views/userPage/qjyl'),
				meta: { keepAlive: false },
			},
			{
				path: '/myshouyi',//我的收益
				component: () => import('@/views/userPage/myshouyi'),
				meta: { keepAlive: false },
			},
			{
				path: '/sdpl',//收到评论
				component: () => import('@/views/userPage/sdpl'),
				meta: { keepAlive: false },
			},
			{
				path: '/plsx',//收到评论 -- 评论筛选
				component: () => import('@/views/userPage/plsx'),
				meta: { keepAlive: false },
			},
			{
				path: '/fcpl',//发出评论
				component: () => import('@/views/userPage/fcpl'),
				meta: { keepAlive: false },
			},
			{
				path: '/zhuanlanset',//专栏设置
				component: () => import('@/views/userPage/zhuanlanset'),
				meta: { keepAlive: false },
			},
			{
				path: '/updataoldtext',//更新旧文
				component: () => import('@/views/userPage/updataOldText'),
				meta: { keepAlive: false },
			},
			{
				path: '/gxjwEdit',//更新旧文-- 编辑页面
				component: () => import('@/views/userPage/gxjwEdit'),
				meta: { keepAlive: false },
			},
			// {
			// 	path: '/fbxw',//发表新文
			// 	component: () => import('@/views/userPage/fbxw'),
			// 	meta: { keepAlive: false },
			// },
			{
				path: '/updataoldtextinfo',//更新旧文详情
				component: () => import('@/views/userPage/updataOldTextInfo'),
				meta: { keepAlive: false },
			},
			{
				path: '/addNewZj',//更新旧文详情 -- 添加章节页面
				component: () => import('@/views/userPage/addNewZj'),
				meta: { keepAlive: false },
			}, 
			{
				path: '/aboutYj',//关于云锦
				component: () => import('@/views/userPage/aboutYj'),
				meta: { keepAlive: false },
			},
			{
				path: '/xtsz',//系统设置
				component: () => import('@/views/userPage/xtsz'),
				meta: { keepAlive: false },
			},
			{
				path: '/xgpassword',//修改密码
				component: () => import('@/views/userPage/xgpassword'),
				meta: { keepAlive: false },
			},
			{
				path: '/bcpassword',//保存密码
				component: () => import('@/views/userPage/bcpassword'),
				meta: { keepAlive: false },
			},
			{
				path: '/querypassword',//确认---保存密码
				component: () => import('@/views/userPage/querypassword'),
				meta: { keepAlive: false },
			},
			{
				path: '/yjfk',//意见反馈
				component: () => import('@/views/userPage/yjfk'),
				meta: { keepAlive: false },
			},
			{
				path: '/fangdaoPage',//防盗
				component: () => import('@/views/userPage/fangdaoPage'),
				meta: { keepAlive: false },
			},
			{
				path: '/chongzhijilu',//充值记录
				component: () => import('@/views/userPage/chongzhijilu'),
				meta: { keepAlive: false },
			},
			{
				path: '/chongzhiPage',//充值记录
				component: () => import('@/views/userPage/chongzhiPage'),
				meta: { keepAlive: false },
			},
			{
				path: '/mylw',//我的礼物
				component: () => import('@/views/userPage/mylw'),
				meta: { keepAlive: false },
			},
			{
				path: '/mylwinfo',//我的礼物详情
				component: () => import('@/views/userPage/mylwinfo'),
				meta: { keepAlive: false },
			},
			{
				path: '/cjwt',//常见问题
				component: () => import('@/views/userPage/cjwt'),
				meta: { keepAlive: false },
			},
			{
				path: '/wtjd',//常见问题 -- 问题解答
				component: () => import('@/views/userPage/wtjd'),
				meta: { keepAlive: false },
			},
			{
				path: '/set',//设置
				component: () => import('@/views/login/set'),
				meta: { keepAlive: false },
			},
			{
				path: '/zfmima',//常见问题
				component: () => import('@/views/userPage/zfmima'),
				meta: { keepAlive: false },
			},
			{
				path: '/qiandao',//签到
				component: () => import('@/views/userPage/qiandao'),
				meta: { keepAlive: false },
			},
			{
				path: '/morexiaoxianv',//查看更多小仙女
				component: () => import('@/views/bookcity/morexiaoxianv'),
				meta: { keepAlive: false },
			},
			{
				path: '/readbook',//阅读书本
				component: () => import('@/views/readbook/readbook'),
				meta: { keepAlive: false },
			},
			{
				path: '/vipread',//阅读书本 -- 解锁章节
				component: () => import('@/views/readbook/vipread'),
				meta: { keepAlive: false },
			},
			{
				path: '/moreset',//阅读书本 -- 更多
				component: () => import('@/views/readbook/moreset'),
				meta: { keepAlive: false },
			},
			{
				path: '/jubao',//举报
				component: () => import('@/views/bookcity/jubao'),
				meta: { keepAlive: false },
			},
			{
				path: '/txzl',//填写资料
				component: () => import('@/views/userPage/txzl'),
				meta: { keepAlive: false },
			},
			{
				path: '/soltPhDetail',//填写资料
				component: () => import('@/views/bookcity/soltPhDetail'),
				meta: { keepAlive: false },
			},
			{
				path: '/forumSearchResult',//论坛搜索结果页
				component: () => import('@/views/forum/forumSearchResult'),
				meta: { keepAlive: false },
			},
			{
				path: '/madeCategry',//定制收藏
				component: () => import('@/views/bookshelf/madeCategry.vue'),
				meta: { keepAlive: false },
			},
			{
				path: '/autherXy',//作者协议
				component: () => import('@/views/login/autherXy'),
				meta: { keepAlive: false },
			},
			{
				path: '/applyHotlist',// 申请榜单
				component: () => import('@/views/userPage/applyHotlist'),
				meta: { keepAlive: false },
			},
		]
	})
	
	export default {
	  router: router
	}